import React, {Component} from 'react'
import PropTypes from 'prop-types'
import './ControlsBar.scss'
import VolumeControl from './VolumeControl'
import FullScreenButton from './FullScreenButton'
import CaptionsControl from './CaptionsControl'

class ControlsBar extends Component {
  static propTypes = {
    hideControlsBar: PropTypes.bool,
    isFixed: PropTypes.bool,
    fullscreenEnabled: PropTypes.bool.isRequired,
    hideFullScreenButton: PropTypes.bool,
    showLogo: PropTypes.bool,
    captionLocales: PropTypes.array,
    setActiveCaptionLocale: PropTypes.func,
    ...VolumeControl.propTypes,
    ...FullScreenButton.propTypes,
    initialCaptionLocale: PropTypes.string
  }

  static defaultProps = {
    showLogo: true
  }

  get volume() {
    return this.refs.volumeControl.actualVolume
  }

  set volume(newVolume) {
    this.refs.volumeControl._handleSetVolume(newVolume)
  }

  toggleMute = () => {
    this.refs.volumeControl.toggleMute()
  }

  stopPropagation = (e) => e.stopPropagation()

  render() {
    const {children,
           hideControlsBar,
           isFixed,
           hideFullScreenButton,
           showLogo,
           hideVolumeControl,
           captionLocales,
           setActiveCaptionLocale,
           initialCaptionLocale,
           ...otherProps} = this.props

    return (
      <div
        styleName={`controls-bar ${hideControlsBar ? 'hide' : ''} ${isFixed ? 'fixed' : ''}`}
        onClick={this.stopPropagation}
      >
        <div styleName="background"/>
        {children}
        <div styleName="base-controls">
          {showLogo && <a href="https://www.powtoon.com" target="_blank" aria-label="Powtoon home page" styleName="brand-powtoon" />}
          <CaptionsControl
            locales={captionLocales}
            setActiveCaptionLocale={setActiveCaptionLocale}
            initialCaptionLocale={initialCaptionLocale}
          />
          {!hideVolumeControl && <VolumeControl ref="volumeControl" {...otherProps} />}
          {!hideFullScreenButton && <FullScreenButton {...otherProps} isFullscreen={isFixed} />}
        </div>
      </div>
    )
  }
}


export default ControlsBar
